import React, { Component, Fragment } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import capitalize from 'capitalize';
import { makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import ActionDelete from '@material-ui/icons/Delete';
import classnames from 'classnames';
import { crudDelete, startUndoable } from 'ra-core';
import IconCancel from '@material-ui/icons/Cancel';
import { Button } from 'react-admin';
import { ListProps } from '../types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    deleteButton: {
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: fade(theme.palette.error.main, 0.12),
            // Reset on mouse devices
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
    },
}));

type Styles = {
    deleteButton: string;
};

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux &
    ListProps & {
        titleSource: string;
        label: string;
        classes: Styles;
        className: string;
        record: any;
        basePath: string;
        redirect: string;
        undoable: boolean;
    };

class DeleteButton extends Component<Props> {
    state = {
        showDialog: false,
    };

    handleClick = () => {
        this.setState({ showDialog: true });
    };

    handleCloseClick = () => {
        this.setState({ showDialog: false });
    };

    handleDelete = event => {
        event.preventDefault();
        this.setState({ showDialog: false });
        const {
            dispatchCrudDelete,
            startUndoable,
            resource,
            record,
            basePath,
            redirect = 'list',
            undoable = false,
        } = this.props;
        if (undoable) {
            startUndoable(
                crudDelete(resource, record.id, record, basePath, redirect)
            );
        } else {
            dispatchCrudDelete(resource, record.id, record, basePath, redirect);
        }
    };

    render() {
        const { showDialog } = this.state;
        const {
            label = 'ra.action.delete',
            classes,
            className,
            resource,
            record,
            titleSource,
        } = this.props;

        return record ? (
            <Fragment>
                <Button
                    onClick={this.handleClick}
                    label={label}
                    className={classnames(
                        'ra-delete-button',
                        classes.deleteButton,
                        className
                    )}
                    key="button"
                >
                    <ActionDelete />
                </Button>
                <Dialog
                    fullWidth
                    open={showDialog}
                    onClose={this.handleCloseClick}
                    aria-label="Are you sure?"
                >
                    <DialogTitle>
                        Deleting “
                        {titleSource
                            ? record[titleSource]
                            : record.title
                            ? record.title
                            : record.name
                            ? record.name
                            : `${capitalize(resource.replace(/s$/, ''))} #${
                                  record.id
                              }`}
                        ”
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            Are you sure you want to delete this entry? This
                            action is permanent.
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleDelete}
                            label={label}
                            className={classnames(
                                'ra-delete-button',
                                classes.deleteButton,
                                className
                            )}
                            key="button"
                        >
                            <ActionDelete />
                        </Button>
                        <Button
                            label="ra.action.cancel"
                            onClick={this.handleCloseClick}
                        >
                            <IconCancel />
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        ) : null;
    }
}

const mapDispatch = {
    startUndoable,
    dispatchCrudDelete: crudDelete,
};

const connector = connect(null, mapDispatch);

const DeleteButtonComponent = connector(DeleteButton);

export default props => {
    const classes = useStyles();

    return <DeleteButtonComponent classes={classes} {...props} />;
};
